import React from "react";
import BookingLink from "../../components/button/BookingLink";

const ContactsUs = () => {
  return (
    <section id="contact-us" className="block">
      <div className="spacer p-top-xl p-bottom-xl">
        <div className="wrapper text-center">
          <div className="title">
            <h2>Réservez votre prochain rendez-vous</h2>
          </div>
          <p className="booking-cta-description">
            Retrouvez les prestations et les disponibilités à jour directement
            sur Planity.
          </p>
          <BookingLink
            className="btn btn-outline-secondary"
            showExternalIcon
          >
            Prendre rendez-vous sur Planity
          </BookingLink>
        </div>
      </div>
    </section>
  );
};

export default ContactsUs;
